import React, { useRef, useEffect } from 'react';
import styles from './styles.module.css';

const CONTACT_EMAIL = 'service@lumination.vn';

// ─── Component ────────────────────────────────────────────────────────────────
export default function ShortSwapPopup({ isOpen, onClose, short }) {
  const videoRef = useRef(null);

  // ── Video playback trong range startTime..endTime ─────────────────────────
  useEffect(() => {
    const video = videoRef.current;
    if (!video || !short) return;

    const handleTimeUpdate = () => {
      if (video.currentTime >= short.endTime) {
        video.currentTime = short.startTime;
        video.pause();
      }
    };

    const handleLoaded = () => {
      video.currentTime = short.startTime;
      video.play().catch(() => {});
    };

    video.addEventListener('timeupdate', handleTimeUpdate);
    video.addEventListener('loadedmetadata', handleLoaded);

    if (video.readyState >= 2) {
      video.currentTime = short.startTime;
      video.play().catch(() => {});
    }

    return () => {
      video.removeEventListener('timeupdate', handleTimeUpdate);
      video.removeEventListener('loadedmetadata', handleLoaded);
    };
  }, [short]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  if (!isOpen || !short) return null;

  const formatTime = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;

  return (
    <div
      className={styles.overlay}
      role="button"
      tabIndex={0}
      onClick={handleOverlayClick}
      onKeyDown={(e) => {
        if (e.key === 'Escape') handleOverlayClick(e);
      }}
    >
      <div className={styles.popup}>
        {/* Header */}
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <span className={styles.shortBadge}>Short ngắn</span>
            <span className={styles.timeRange}>
              {formatTime(short.startTime)} → {formatTime(short.endTime)}
            </span>
          </div>
          <button type="button" className={styles.closeBtn} onClick={onClose}>
            ✕
          </button>
        </div>

        <div className={styles.body}>
          {/* ── Left column ── */}
          <div className={styles.leftCol}>
            {/* Section 1: Video gốc */}
            <div className={styles.section}>
              <div className={styles.sectionLabel}>
                <span className={styles.sectionNum}>1</span>
                Đoạn phim ngắn
              </div>
              <div className={styles.videoWrapper}>
                <video ref={videoRef} src={short.url} className={styles.shortVideo} controls playsInline />
                <div className={styles.timeBadge}>
                  {formatTime(short.startTime)} – {formatTime(short.endTime)}
                </div>
              </div>
            </div>

            {/* Section 2: Upload ảnh */}
            <div className={styles.section}>
              <div className={styles.sectionLabel}>
                <span className={styles.sectionNum}>2</span>
                Tải hình ảnh lên
              </div>
              <div className={`${styles.uploadArea} ${styles.uploadAreaDisabled}`}>
                <div className={styles.uploadPlaceholder}>
                  <div className={styles.uploadText}>Tính năng Face Swap đang tạm khóa</div>
                  <div className={styles.uploadHint}>Hiện không hỗ trợ upload hình ảnh ở đây</div>
                </div>
              </div>
              <div className={styles.featureWarning}>
                Muốn sử dụng tính năng này, vui lòng liên hệ email{' '}
                <a href={`mailto:${CONTACT_EMAIL}`} className={styles.featureWarningLink}>
                  {CONTACT_EMAIL}
                </a>
                .
              </div>
            </div>

            {/* Section 3: Generate buttons */}
            {/* <div className={styles.section}>
              <div className={styles.sectionLabel}>
                <span className={styles.sectionNum}>3</span>
                Chọn chế độ Generate
              </div>
              <div className={styles.featureWarning}>
                Nút Generate đã được ẩn tạm thời. Vui lòng liên hệ{' '}
                <a href={`mailto:${CONTACT_EMAIL}`} className={styles.featureWarningLink}>
                  {CONTACT_EMAIL}
                </a>{' '}
                nếu cần bật lại tính năng.
              </div>
            </div> */}
          </div>

          {/* ── Right column: kết quả ── */}
          <div className={styles.rightCol}>
            <div className={styles.section}>
              <div className={styles.sectionLabel}>
                <span className={styles.sectionNum}>4</span>
                Kết quả
              </div>
              <div className={styles.resultArea}>
                <div className={styles.emptyResult}>
                  <div className={styles.emptyIcon}>🎬</div>
                  <div className={styles.emptyText}>Tính năng Face Swap đang tạm thời không khả dụng</div>
                  <div className={styles.emptyHint}>Liên hệ {CONTACT_EMAIL} để được hỗ trợ mở quyền sử dụng</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
